import { PHYSICS } from "@golazo/shared";

export interface LoopCallbacks {
  /** Se llama N veces por frame, siempre con el mismo `dt`. Aqui va la fisica. */
  tick(dt: number): void;
  /** Se llama una vez por frame. `alpha` en [0,1) para interpolar. */
  render(alpha: number): void;
}

export interface Loop {
  start(): void;
  stop(): void;
}

/**
 * Bucle de tick fijo con acumulador. La fisica avanza siempre en pasos de
 * 1/60 s pase lo que pase con el framerate, y el render interpola el resto.
 */
export function createLoop({ tick, render }: LoopCallbacks): Loop {
  let handle = 0;
  let running = false;
  let lastTime = 0;
  let accumulator = 0;

  const maxFrameTime = PHYSICS.DT * PHYSICS.MAX_TICKS_PER_FRAME;

  const frame = (now: number): void => {
    if (!running) return;
    handle = requestAnimationFrame(frame);

    // Acotar el delta evita que, tras un stall (pestana en segundo plano),
    // el acumulador dispare cientos de ticks de golpe.
    const elapsed = Math.min((now - lastTime) / 1000, maxFrameTime);
    lastTime = now;
    accumulator += elapsed;

    while (accumulator >= PHYSICS.DT) {
      tick(PHYSICS.DT);
      accumulator -= PHYSICS.DT;
    }

    render(accumulator / PHYSICS.DT);
  };

  return {
    start(): void {
      if (running) return;
      running = true;
      lastTime = performance.now();
      accumulator = 0;
      handle = requestAnimationFrame(frame);
    },
    stop(): void {
      running = false;
      cancelAnimationFrame(handle);
    },
  };
}
